export const usersFeatures = {
  showInviteUser: [
    "gytis.stepucinskas@teltonika.lt",
    "aurimas.vanagas@teltonika.lt",
    "tadas.zeimo@teltonika.lt",
    "dominykas.grauzinis@teltonika.lt",
    "paulius.garbasauskas@teltonika.lt",
    "remigijus.pankevicius@teltonika.lt",
    "autotests@teltonika.lt",
    "orinta.romanovskaja@teltonika.lt"
  ],
  allowedFullControlOfUsers: [
    "gytis.stepucinskas@teltonika.lt",
    "aurimas.vanagas@teltonika.lt",
    "deividas.santaras@teltonika.lt"
  ],
  allowFeatureSwitches: [
    "gytis.stepucinskas@teltonika.lt",
    "tadas.zeimo@teltonika.lt",
    "dominykas.grauzinis@teltonika.lt",
    "paulius.garbasauskas@teltonika.lt",
    "mindaugas.liogys@teltonika.lt",
    "autotests@teltonika.lt",
    "orinta.romanovskaja@teltonika.lt",
    "julius.blusevicius@teltonika.lt",
    "grauzinis.dominykas@gmail.com",
    "diana.bauzyte@teltonika.lt",
    "justas.radveikis@teltonika.lt"
  ]
};
